import { Observable } from 'rxjs';
import { ICaptchaResponse, ICredentials } from './auth.model';

export abstract class AuthService {
	abstract get authenticated(): boolean;

	abstract get currentPageIsEntry(): boolean;

	abstract get tokenPayload(): any;

	abstract get token(): string;

	abstract get userId(): number;

	abstract get userLogin(): string;

	abstract isAdmin$: Observable<boolean>;

	abstract isAdmin: boolean;

	abstract reincarnateFromUserId$: Observable<number>;

	/**Режим перевоплощения */
	abstract isReincarnateMode$: Observable<boolean>;

	abstract authenticated$: Observable<boolean>;

	abstract error$: Observable<any>;

	abstract loading$: Observable<boolean>;

	abstract isCaptchaRequired$: Observable<boolean>;

	abstract navigateToSignInPage(
		backUrl?: string,
		queryParams?: { [key: string]: string | number | boolean },
		replaceUrl?: boolean
	): Promise<boolean>;

	abstract navigateToSignUpPage(replaceUrl?: boolean): Promise<boolean>;

	abstract login(credentials: ICredentials): void;

	abstract logout(): void;

	abstract clearToken(): void;

	abstract checkAuthBySentRequest(): Observable<{ isAuth: boolean; token: string }>;

	abstract undoReincarnation(): Observable<any>;

	abstract impersonate(userId: string | number): Observable<any>;

	abstract getCaptcha(): Observable<ICaptchaResponse>;
}
